import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { useTracking } from "react-tracking";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsGenericComponent = ( { componentName } ) => {
  const { trackEvent } = useTracking();

  const { isUserAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    trackEvent({ component: componentName, event: `${componentName}-Clicked` });
  }, []);

  return <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
    {isUserAuthenticated && (
      <DisplayNameAndRole />
    )}
  </div>;
};

export default NavbarIconsGenericComponent;
